import { useFlagBasedOnJSONDomain } from '@components/Flag';

export const useEmployeeV2Flag = (): boolean => {
  const useEmployeeV2 = useFlagBasedOnJSONDomain(
    'ME-35786-feat-employee-migration-v2'
  );
  return useEmployeeV2;
};
